import { ArrowRightIcon } from 'lucide-react'

import { Button } from '@/components/button/button'
import { Card, CardContent } from '@/components/card/card'

import { cn } from '@/lib/utils'

import noData from './no-data.svg'

export interface NoDataCardProps {
  cardTitle: string
  cardDescription: string
  buttonLabel: string
  onClickButton: VoidFunction
}

export const NoDataCard = ({ cardTitle, cardDescription, buttonLabel, onClickButton }: NoDataCardProps) => {
  return (
    <Card>
      <CardContent className={cn('p-6')}>
        <div className={cn('flex flex-col items-center justify-center', 'p-5', 'rounded-[10px]', 'bg-secondary')}>
          <div>
            <img src={noData} alt="Data not found" className={cn('mx-auto')} />
            <p className={cn('text-center text-lg font-semibold text-black', 'mt-[18px]')}>{cardTitle}</p>
            <p className={cn('text-center text-base font-normal text-muted-foreground', 'mt-2.5')}>{cardDescription}</p>
          </div>
          <div className={cn('mt-5')}>
            <Button type="button" size="sm" variant="default" className={cn('flex gap-x-2')} onClick={onClickButton}>
              {buttonLabel}
              <ArrowRightIcon size={16} />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
